const subUsersPT = {
    "view": {
        "table": {
            "title": "Sua lista de sub-usuários",
            "column": {
                "username": "Nome de Usuário",
                "email": "Email",
                "first_name": "Primeiro Nome",
                "last_name": "Sobrenome",
                "company": "Empresa",
                "sub_user_deal": "Acordo (%)",
                "contract_expiry": "Expiração do Contrato",
                "is_active": "Ativo",
                "action": "Ação"
            },
            "button": {
                "edit": "Editar",
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "label": {
                "yes": "Sim",
                "no": "Não"
            },
            "dropdown": {
                "action": "Ação",
                "edit": "Editar",
                "activate": "Ativar",
                "deactivate": "Desativar"
            }
        },
        "message": {
            "successUpdated": "Conta do sub-usuário foi atualizada!",
            "successActivated": "Conta do sub-usuário foi ativada!",
            "successDeactivated": "Conta do sub-usuário foi desativada!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "premiumUsersOnly": "Este recurso é oferecido apenas para Usuários Premium. Por favor, entre em contato com a equipe de suporte se desejar atualizar sua conta.",
            "noAccess": "Você não tem acesso a este módulo, por favor, entre em contato com a equipe de suporte para mais informações."
        },
        "modal": {
            "activateSubuser": {
                "header": "Ativar Sub-usuário",
                "body": "Tem certeza de que deseja Ativar o Sub-Usuário {{username}}?"
            },
            "deactivateSubuser": {
                "header": "Desativar Sub-usuário",
                "body": "Tem certeza de que deseja Desativar o Sub-Usuário {{username}}?"
            },
            "button": {
                "cancel": "Cancelar",
                "edit": "Editar",
                "activate": "Ativar",
                "deactivate": "Desativar"
            }
        }
    },
    "add": {
        "title": "Adicionar Sub-usuário",
        "form": {
            "label": {
                "personalDetails": "Detalhes Pessoais",
                "firstName": "Primeiro Nome",
                "lastName": "Sobrenome",
                "email": "Email",
                "username": "Nome de Usuário",
                "password": "Senha",
                "confirmPassword": "Confirmar Senha",
                "businessDetails": "Detalhes Comerciais",
                "companyName": "Nome da Empresa",
                "contractExpiry": "Expiração do Contrato",
                "subUserDeal": "Acordo do Subusuário (%)",
                "nationalTaxNumber": "Número de Imposto Nacional",
                "businessRegistrationNumber": "Número de Registro Comercial",
                "contactDetails": "Detalhes de Contato",
                "streetAndNumber": "Rua e número da casa",
                "postalCode": "Código Postal",
                "city": "Cidade",
                "country": "País",
                "phoneNumber": "Número de Telefone"
            },
            "help_text": {
                "contractExpiry": "Nota: A data de Expiração do Contrato não pode ser definida antes de {{afterOneYear}}."
            },
            "button": {
                "submit": "Enviar"
            }
        },
        "message": {
            "success": "Sub-Usuário foi adicionado!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        },
        "modal": {
            "header": "Adicionar Sub-Usuário",
            "body": "Tem certeza de que deseja criar um novo sub-usuário?"
        }
    },
    "update": {
        "title": "Editar Sub-usuário",
        "form": {
            "label": {
                "personalDetails": "Detalhes Pessoais",
                "firstName": "Primeiro Nome",
                "lastName": "Sobrenome",
                "email": "Email",
                "username": "Nome de Usuário",
                "password": "Senha",
                "confirmPassword": "Confirmar Senha",
                "businessDetails": "Detalhes Comerciais",
                "companyName": "Nome da Empresa",
                "contractExpiry": "Expiração do Contrato",
                "subUserDeal": "Acordo do Subusuário (%)",
                "nationalTaxNumber": "Número de Imposto Nacional",
                "businessRegistrationNumber": "Número de Registro Comercial",
                "contactDetails": "Detalhes de Contato",
                "streetAndNumber": "Rua e número da casa",
                "postalCode": "Código Postal",
                "city": "Cidade",
                "country": "País",
                "phoneNumber": "Número de Telefone"
            },
            "help_text": {
                "contractExpiry": "Nota: A data de Expiração do Contrato não pode ser definida antes de {{afterOneYear}}."
            },
            "button": {
                "submit": "Enviar"
            }
        },
        "message": {
            "success": "Sub-Usuário foi atualizado!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        }
    }
};

export default subUsersPT;